module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tvInfo.length > 0) ? _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "searchbar row"
  }, [_c('div', {
    staticClass: "search-input col-80",
    staticStyle: {
      "margin-left": "1.5rem",
      "width": "73%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchdata),
      expression: "searchdata"
    }],
    attrs: {
      "id": "search",
      "placeholder": "载体"
    },
    domProps: {
      "value": (_vm.searchdata)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchdata = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "button button-fill button-primary col-15",
    on: {
      "click": function($event) {
        return _vm.filterTVOptions(_vm.TVInfoFilters)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content-block-title title-label"
  }, [_vm._v("筛选项")]), _vm._v(" "), _vm._l((_vm.filterOptionAttributes), function(filter, index) {
    return _c('div', {
      staticClass: "filter-option"
    }, [_c('van-dropdown-menu', {
      attrs: {
        "index": index
      }
    }, [_c('van-dropdown-item', {
      attrs: {
        "title": filter.name,
        "disabled": "",
        "title-class": "blue-title"
      }
    }), _vm._v(" "), _c('van-dropdown-item', {
      attrs: {
        "options": _vm.filterOptions[filter.attribute]
      },
      model: {
        value: (_vm.TVInfoFilters[filter.data]),
        callback: function($$v) {
          _vm.$set(_vm.TVInfoFilters, filter.data, $$v)
        },
        expression: "TVInfoFilters[filter.data]"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "content-block-title title-label"
  }, [_vm._v(_vm._s(this.attribute.label))]), _vm._v(" "), (_vm.serarchOptions.length > 0 || _vm.onlyShowSearchOptions) ? _c('ul', {
    staticStyle: {
      "padding-left": "0rem"
    }
  }, _vm._l((_vm.serarchOptions), function(opt, idx) {
    return _c('li', [(_vm.showCustomMade(opt.WQFlag)) ? _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attribute.value),
        expression: "attribute.value"
      }],
      attrs: {
        "type": "radio",
        "name": "my-radio"
      },
      domProps: {
        "value": opt.TLNo,
        "checked": _vm._q(_vm.attribute.value, opt.TLNo)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.attribute, "value", opt.TLNo)
        }
      }
    }), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      on: {
        "click": _vm.changePeriod
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.8rem"
      }
    }, [_vm._v("\n              " + _vm._s(opt.TLNo) + "\n             ")]), _vm._v(" "), (opt.promoterAAV !== undefined) ? _c('span', {
      staticStyle: {
        "margin-right": "0.8rem"
      }
    }, [_vm._v("\n               " + _vm._s(opt.promoterAAV) + "\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 1) ? _c('span', [_vm._v("\n                推荐\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 2) ? _c('span', [_vm._v("\n                可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 3) ? _c('span', [_vm._v("\n               不可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.tag5ID === 1) ? _c('span', [_vm._v("\n               特异性启动子\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v("\n            " + _vm._s(opt.elementSeq) + "\n          ")]), _vm._v(" "), (opt.RNAiEffect) ? _c('span', [_vm._v("包装容量：" + _vm._s(opt.RNAiEffect))]) : _vm._e(), _vm._v(" "), (opt.recommendSerotype) ? _c('div', [_vm._v("小鼠参考血清型：" + _vm._s(opt.recommendSerotype))]) : _vm._e(), _vm._v(" "), (opt.toolVectorApply) ? _c('div', [_vm._v("载体适用：" + _vm._s(opt.toolVectorApply))]) : _vm._e()])]) : _vm._e()])
  }), 0) : _c('ul', {
    staticStyle: {
      "padding-left": "0rem"
    }
  }, _vm._l((_vm.tvInfo), function(opt, idx) {
    return _c('li', [(_vm.showCustomMade(opt.WQFlag)) ? _c('label', {
      staticClass: "label-checkbox item-content"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.attribute.value),
        expression: "attribute.value"
      }],
      attrs: {
        "type": "radio",
        "name": "my-radio"
      },
      domProps: {
        "value": opt.TLNo,
        "checked": _vm._q(_vm.attribute.value, opt.TLNo)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.attribute, "value", opt.TLNo)
        }
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner",
      on: {
        "click": _vm.changePeriod
      }
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('span', {
      staticStyle: {
        "margin-right": "0.5rem"
      }
    }, [_vm._v("\n              " + _vm._s(opt.TLNo) + "\n             ")]), _vm._v(" "), (opt.promoterAAV !== undefined) ? _c('span', {
      staticStyle: {
        "margin-right": "0.5rem"
      }
    }, [_vm._v("\n               " + _vm._s(opt.promoterAAV) + "\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 1) ? _c('span', [_vm._v("\n                推荐\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 2) ? _c('span', [_vm._v("\n               可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.WQFlag === 3) ? _c('span', [_vm._v("\n               不可用\n            ")]) : _vm._e(), _vm._v(" "), (opt.tag5ID === 1) ? _c('span', [_vm._v("\n                     特异性启动子\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(" " + _vm._s(opt.elementSeq))]), _vm._v(" "), (opt.RNAiEffect && opt.RNAiEffect !== '0') ? _c('span', [_vm._v("包装容量：" + _vm._s(opt.RNAiEffect))]) : _vm._e(), _vm._v(" "), (opt.recommendSerotype) ? _c('div', [_vm._v("小鼠参考血清型：" + _vm._s(opt.recommendSerotype))]) : _vm._e(), _vm._v(" "), (opt.toolVectorApply) ? _c('div', [_vm._v("载体适用：" + _vm._s(opt.toolVectorApply))]) : _vm._e()])]) : _vm._e()])
  }), 0)], 2) : _c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', [_vm._v("没有可选择的载体编号，请选择下一步！")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6352c013","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/AttrTVBox.vue
// module id = 1661
// module chunks = 8